<template>
  <div class="apply">
    <div class="box-card">
      <div class="head">
        <span class="applyTitle">{{ $t("navbar.catalogue") }}</span>
        <span class="applyEnd">{{$t("active.tishi")}}{{ $t("catalogue.time")}}</span>
      </div>
      <div class="introduce">
        <div class="shuoMing">{{ $t("common.explain") }}</div>

        <div class="box">
          <div class="txt">
            {{ $t("catalogue.explain1") }}
          </div>

          <div class="txt">
            {{ $t("catalogue.explain2") }}
          </div>

          <div class="txt">
            {{ $t("catalogue.explain3") }}
          </div>

          <div class="txt">
            {{ $t("catalogue.explain4") }}
          </div>

          <div class="txt">
            {{ $t("catalogue.explain5") }}
          </div>

          <div class="txt">
            {{ $t("catalogue.explain6") }}
          </div>
        </div>
      </div>

      <!--  表单开始 -->
      <div class="instance">
        <div class="content">
          <el-form
            :model="catalogueMsg"
            ref="catalogueMsg"
            label-width="220px"
            :disabled="flag == '2' ? true : false"
            :rules="rules"
          >
            <el-form-item
              :label="$t('exhiInformat.cnname') + '：'"
              prop="companyNameC"
            >
              <span>{{ catalogueMsg.companyNameC }}</span>
            </el-form-item>

            <el-form-item
              :label="$t('exhiInformat.enname') + '：'"
              prop="column14"
              :rules="[
                { required: true, message: $t('catalogue.companyTishi') },
              ]"
            >
              <el-input
                type="age"
                v-model="catalogueMsg.column14"
                autocomplete="off"
                :placeholder="$t('catalogue.placeholder')"
                maxlength="300"
                show-word-limit
              ></el-input>
            </el-form-item>

            <el-form-item
              :label="$t('homepage.positionNumber') + '：'"
              prop="boothNum"
            >
              <span>{{ addcomma(hzBoothList) }}</span>
            </el-form-item>

            <el-form-item
              :label="$t('catalogue.companyAddress') + '：'"
              prop="column15"
            >
              <el-input
                type="age"
                v-model="catalogueMsg.column15"
                autocomplete="off"
                :placeholder="$t('catalogue.placeholder1')"
                maxlength="200"
              ></el-input>
            </el-form-item>

            <el-form-item
              :label="$t('catalogue.companyAddressEn') + '：'"
              prop="column16"
            >
              <el-input
                type="age"
                v-model="catalogueMsg.column16"
                autocomplete="off"
                :placeholder="$t('catalogue.placeholder2')"
                maxlength="200"
              ></el-input>
            </el-form-item>

            <el-form-item :label="$t('exhiInformat.postCode')" prop="column23">
              <el-input
                type="age"
                v-model="catalogueMsg.column23"
                autocomplete="off"
                :placeholder="$t('catalogue.placeholder3')"
                maxlength="100"
              ></el-input>
            </el-form-item>

            <el-form-item
              :label="$t('catalogue.telephone') + '：'"
              prop="telephone"
            >
              <el-input
                type="age"
                v-model="catalogueMsg.telephone"
                autocomplete="off"
                :placeholder="$t('catalogue.placeholder4')"
                maxlength="100"
              ></el-input>
            </el-form-item>

            <el-form-item label="E-mail：" prop="email">
              <el-input
                type="input"
                v-model="catalogueMsg.email"
                autocomplete="off"
                :placeholder="$t('catalogue.placeholder5')"
                maxlength="100"
              ></el-input>
            </el-form-item>

            <el-form-item
              :label="$t('catalogue.address') + '：'"
              prop="column24"
            >
              <el-input
                type="age"
                v-model="catalogueMsg.column24"
                autocomplete="off"
                :placeholder="$t('catalogue.placeholder6')"
                maxlength="100"
              ></el-input>
            </el-form-item>

            <!-- 文本域 -->
            <div class="aa">
              <el-form-item
                :label="$t('product.cnintroduce') + '：'"
                prop="introduceC"
              >
                <el-input
                  type="textarea"
                  :rows="3"
                  @input="ctxt"
                  v-model="catalogueMsg.introduceC"
                
                ></el-input>
                <p class="numberV">
                  {{ $t("catalogue.hint")
                  }}<span class="remaining">{{ ctext }}</span
                  >{{ $t("catalogue.hint2", { number: 100 }) }}
                </p>
              </el-form-item>
            </div>

            <!-- 文本域 -->
            <div class="aa">
              <el-form-item
                :label="$t('product.enintroduce') + '：'"
                prop="introduceE"
              >
                <el-input
                  type="textarea"
                  @input="etxt"
                  v-model="catalogueMsg.introduceE"
                  :rows="3"
                
                ></el-input>
                <p class="numberV">
                  {{ $t("catalogue.hint")
                  }}<span class="remaining">{{ etext }}</span
                  >{{ $t("catalogue.hint2", { number: 500 }) }}
                </p>
              </el-form-item>
            </div>
            <!-- 文本域 -->
          </el-form>
        </div>
      </div>
      <!--  表单结束 -->

      <!-- 展品分类说明 -->
      <div class="instance">
        <p class="title">{{ $t("catalogue.exhibClass") }}</p>
        <div class="txt">
          <span class="shuoMing">{{ $t("common.explain") }}</span>
          {{ $t("catalogue.hint3") }}
        </div>

        <!------------展品分类目录--------------->
        <div class="box">
          <div class="item" v-for="(item, index) in equipment" :key="index">
            <div class="left">{{ item.label }}</div>

            <el-collapse
              class="right"
              v-model="activeNames"
              @change="handleChange"
            >
              <el-collapse-item
                @click.native="qieHuan(index, i)"
                :name="i.label"
                v-for="(i, k) in item.child"
                :key="k"
              >
                <template slot="title">
                  <span class="twoTitle">{{ i.label }}</span>
                  <span class="folding" v-if="i.folding">{{
                    $t("catalogue.open")
                  }}</span>
                  <span class="folding" v-else>{{ $t("catalogue.down") }}</span>
                </template>

                <div class="cycle">
                  <span>
                    <el-checkbox-group v-model="checkList" v-if="item.child">
                      <el-checkbox
                        :label="it.label"
                        v-for="(it, kt) in i.child"
                        :key="kt"
                        @change="changeBox(item.title, i.title, it.title)"
                      ></el-checkbox>
                    </el-checkbox-group>
                  </span>
                </div>
              </el-collapse-item>
            </el-collapse>
          </div>
        </div>
        <!------------------------------------->
        <div class="bottom">
          <div>
            <el-form
              :model="catalogueMsg"
              ref="category"
              label-width="100px"
              class="ruleForm"
            >
              <!-- 文本域 -->
              <div class="category">
                <el-form-item :label="$t('catalogue.other')" prop="labelDesc">
                  <el-input
                    type="textarea"
                    :rows="3"
                    v-model="catalogueMsg.labelDesc"
                  ></el-input>
                </el-form-item>
              </div>
            </el-form>
          </div>

          <div class="btn">
            <div class="why" v-if="flag === '-1'">
              {{ $t("active.noPass")
              }}<el-tooltip
                class="item"
                effect="dark"
                :content="catalogueMsg.cause"
                placement="top-start"
              >
                <router-link to="#"> {{ $t("active.cause") }}</router-link>
              </el-tooltip>
            </div>
            <el-button
              type="primary"
              v-if="flag == '' || flag == -1"
              @click="submitForm('catalogueMsg')"
              >{{ $t("common.submit") }}</el-button
            >
            <el-button
              type="primary"
              style="background: #006fb8"
              v-if="flag === '2'"
              disabled
              >{{ $t("active.inreview") }}</el-button
            >
            <el-button
              type="primary"
              style="background: #006fb8"
              v-if="flag === '0'"
              disabled
              >{{ $t("active.approve") }}</el-button
            >
            <el-button
              type="primary"
              style="background: #006fb8"
              @click="submitForm('catalogueMsg')"
              v-if="flag === '0'"
              >{{ $t("catalogue.modifi") }}</el-button
            >
          </div>
        </div>
      </div>
      <!-- --------------------------------- -->
    </div>
    <!-- 展品分类说明 -->
    <!-- <el-dialog :visible.sync="dialogVisible" width="30%" :before-close="handleClose">
      <div>提交成功</div>
      <div>信息已经提交主办方审核,请注意关注审核结果;</div>
    </el-dialog> -->
  </div>
</template>
<script>
import equipmentEn from "../../../Json/exhiListEn.js";
import equipmentCn from "../../../Json/exhiListCn.js";
import { getInfo, commitProceedingInfo } from "../../../../api/cataloge.js";
import { getBooth } from "../../../../api/exhibitor";
export default {
  data() {
    // var validatorPhone = (rule, value, callback) => {
    //   const reg = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/;
    //   const reg2 = /((\d{11})|^((\d{7,8})|(\d{4}|\d{3})-(\d{7,8})|(\d{4}|\d{3})-(\d{7,8})-(\d{4}|\d{3}|\d{2}|\d{1})|(\d{7,8})-(\d{4}|\d{3}|\d{2}|\d{1}))$)/;
    //   if (reg2.test(value) === false) {
    //     callback(new Error('电话号码格式不合规，请重新输入'));
    //   } else {
    //     callback();
    //   }
    // };

    return {
      // rules: {
      //   companyNameC: [{ required: true, message: "公司名称.中文不能为空" }],
      //   column14: [{ required: true, message: "公司名称.英文不能为空" }],
      //   column15: [{ required: true, message: "公司地址·中文不能为空" }],
      //   column16: [{ required: true, message: "公司地址·英文不能为空" }],
      //   telephone: [{ required: true, message: "电话不能为空" }],
      //   email: [
      //     { required: true, message: "邮箱不能为空" },
      //     { validator: validatorEmail, trigger: "blur" },
      //   ],
      //   introduceC: [{ required: true, message: "展品介绍.中文不能为空" }],
      //   introduceE: [{ required: true, message: "展品介绍.英文不能为空" }],
      // },
      dialogVisible: false,
      currentCheck: [],
      // activeNames: ['采煤设备1', '工作面支护1', '工作面输送设备1'],
      activeNames: [],
      verify: "",
      equipment: equipmentCn,
      //会刊信息表单对象
      catalogueMsg: {
        introduceC: "", //展品介绍中文
        introduceE: "", //展品介绍英文文
        proExhibitsList: [], //展品列表
        telephone: "", //手机号
        column14: "", //公司英文名称
        column15: "", //公司中文地址
        column16: "", //公司英文地址
        column23: "", //邮编
        column24: "", //网址
        email: "", //电子邮箱
        labelDesc: "", //其他产品类别
        companyNameC: "", //公司名称
        boothNum: "", //展位号
        cause: "", //审核未通过原因
      },
      ctext: 100, //中文剩余
      etext: 500, //英文剩余

      //复选框组,存储选中的数组
      checkList: [],
      typeLists: [],
      //标志位
      flag: "",
      hzBoothList: [], //展位循环
    };
  },
  computed: {
    rules() {
      var validatorEmail = (rule, value, callback) => {
        const reg = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;
        if (reg.test(value) === false) {
          callback(new Error(this.$t("catalogue.rules.emial")));
        } else {
          callback();
        }
      };
      return {
        companyNameC: [
          { required: true, message: this.$t("catalogue.rules.companyNameC") },
        ],
        column14: [
          { required: true, message: this.$t("catalogue.rules.column14") },
        ],
        column15: [
          { required: true, message: this.$t("catalogue.rules.column15") },
        ],
        column16: [
          { required: true, message: this.$t("catalogue.rules.column16") },
        ],
        telephone: [
          { required: true, message: this.$t("catalogue.rules.telephone") },
        ],
        email: [
          { required: true, message: this.$t("catalogue.rules.email_null") },
          { validator: validatorEmail, trigger: "blur" },
        ],
        introduceC: [
          { required: true, message: this.$t("catalogue.rules.introduceC") },
        ],
        introduceE: [
          { required: true, message: this.$t("catalogue.rules.introduceE") },
        ],
      };
    },
  },
  methods: {
    delItem(item, list) {
      // 表示先获取这个元素的下标，然后从这个下标开始计算，删除长度为1的元素
      list.splice(list.indexOf(item), 1);
    },

    changeBox(one, second, third) {
      const string = one + "-" + second + "-" + third;
      if (this.typeLists.length == 0) {
        this.typeLists.push(string.toString());
      } else {
        if (this.typeLists.includes(string.toString())) {
          // 数组存在当前项，执行删除
          this.delItem(string.toString(), this.typeLists);
        } else {
          // 新增
          this.typeLists.push(string.toString());
        }
      }
      this.catalogueMsg.column11 = this.typeLists.join("#");
    },
    qieHuan(index, item) {
      item.folding = !item.folding;
    },
    // 会刊信息提交
    submitForm(formName) {
    
      if(this.catalogueMsg.introduceC.length > 100){
        this.$message({
          type: "error",
          message: this.$t("product.rules.message3"),
        });
        return;
      }
      if(this.catalogueMsg.introduceE.length > 500){
        this.$message({
          type: "error",
          message: this.$t("product.rules.message4"),
        });
        return;
      }
      // this.dialogVisible = true;
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          this.catalogueMsg.proExhibitsList = this.checkList;
          const params = this.catalogueMsg;
          try {
            const { data } = await commitProceedingInfo(params);
            if (data.code === 200) {
              this.$message({
                type: "success",
                message: this.$t("dialog.message16"),
              });
              this.getInitData();
            }
          } catch (err) {
            this.$message({
              type: "error",
              message: this.$t("dialog.message17"),
            });
            return false;
          }
        } else {
          this.$message.error(this.$t("dialog.message18"));
          // return false;
        }
      });
    },
    async getBootList() {
      const { data } = await getBooth();

      let BoothNumList = data.data;
      //  console.log("当前展位的数据是",BoothNumList);

      if (BoothNumList.length > 0) {
        BoothNumList.forEach((item, index) => {
          this.hzBoothList.push(item.boothNum);
        });
      }
    },
    //文本域计算剩余字数
    ctxt() {
      this.ctext = 100 - Number(this.catalogueMsg.introduceC.length) > 0 ? 100 - Number(this.catalogueMsg.introduceC.length) :0 ;
    },
    etxt() {
      this.etext = 500 - Number(this.catalogueMsg.introduceE.length) >0  ? 500 - Number(this.catalogueMsg.introduceE.length) : 0;
    },
    handleChange(val) {
      const index = val[0];
      let str = null;
      let arr = [...val];
      arr.shift();
      // this.equipment[index].child.forEach((item) => {
      //   item.folding = true;
      // });
      // this.foldClose(arr, index, str);
    },
    addcomma(arr) {
      return arr.join("、");
    },

    foldClose(arr, index, str) {
      // if (arr.length != 0) {
      //   arr.forEach((item) => {
      //     str = item.replace(/1/, '');
      //     this.equipment[index].child.forEach((i) => {
      //        i.title == str ? (i.folding = false) : '';
      //     });
      //   });
      // } else {
      //   this.equipment[index].child.forEach((i) => {
      //     i.folding = true;
      //   });
      // }
    },
    async getInitData() {
      try {
        const { data } = await getInfo();
        // console.log("会刊信息的数据",data);
        this.flag = data.data.auditFlag;
        this.catalogueMsg = data.data;
        const string = data.data.column11;
        if (string) {
          const arr = string.split("#");
          let arr1;
          const arr2 = [];
          arr.map((item) => {
            arr1 = item.split("-");
            arr2.push(arr1[1]);
          });
          this.activeNames = Array.from(new Set(arr2));

          this.checkList = data.data.proExhibitsList;
          const currentList = data.data.column11.split("#");
          this.typeLists = currentList;
        }
      } catch (err) {
        console.log(err);
      }
    },
  },
  created() {
    this.getInitData();
    this.getBootList();
    if(localStorage.getItem('lang')=='en'){
       this.equipment = equipmentEn;
    }else{
      this.equipment = equipmentCn;
    }
  },

  watch: {
    "$i18n.locale"(newValue) {
      if (this.$i18n.locale === "zh") {
        this.equipment = equipmentCn;
      } else if (this.$i18n.locale === "en") {
        this.equipment = equipmentEn;
      }
    },
  },
};
</script>
<style scoped lang="scss">
.apply {
  box-sizing: border-box;
  background: #f0f2f5;
  .box-card {
    width: 100%;
    border-radius: 2px;
    background: #ffffff;
    .head {
      padding: 17px 0px;
      border-bottom: 1px solid #e8e8e8;
      .applyTitle {
        font-size: 20px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 600;
        color: #333333;
        line-height: 24px;
        margin-left: 26px;
      }
      .applyEnd {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #666666;
        line-height: 17px;
        margin-left: 17px;
      }
    }
    //说明
    .introduce {
      margin: 26px 17px 0px 17px;
      padding-bottom: 10px;
      background: #f6f6f7;
      display: flex;
      justify-content: flex-start;
      flex-wrap: wrap;
      .box {
        flex: 1;
        padding-left: 10px;
        .txt {
          box-sizing: border-box;
          position: relative;
          padding-top: 9px;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #333333;
        }
      }
      .shuoMing {
        margin-left: 65px;
        padding-top: 7px;
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #ff190c;
      }
    }
    //标题
    .instance {
      margin: 0px 17px 0px 17px;
      .title {
        padding: 35px 0px 9px 0px;
        border-bottom: 1px solid #e9e9e9;
        font-size: 18px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 500;
        color: #333333;
        line-height: 22px;
      }
      .txt {
        margin-top: 17px;
        padding-left: 65px;
        box-sizing: border-box;
        position: relative;
        padding-top: 9px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #333333;
        height: 36px;
        background: #f6f6f7;
        .shuoMing {
          font-size: 16px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #ff190c;
          padding-right: 5px;
        }
      }

      .content {
        width: 50%;
        margin: 0 auto;
        margin-top: 35px;
        position: relative;
        left: -40px;
        .telNumber {
          color: #006fb8;
          margin-left: 5px;
        }
        .numberV {
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #999999;
          line-height: 19px;
          letter-spacing: 1px;
          .remaining {
            color: #ff190c;
          }
        }
      }
      //展品信息分类
      .box {
        width: 60%;
        position: relative;
        left: 161px;
        //每一项开始
        .item {
          width: 100%;
          display: flex;
          justify-content: space-between;
          .left {
            width: 172px;
            font-size: 16px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #333333;
            line-height: 19px;
            text-align: right;
            padding-right: 17px;
            padding-top: 10px;
            box-sizing: border-box;
          }
          .right {
            flex: 1;
            position: relative;
            .twoTitle {
              font-size: 14px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #333333;
            }

            .folding {
              position: absolute;
              right: 30px;
              font-size: 12px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #666666;
            }
          }
        }

        //每一项结束
      }
      .bottom {
        width: 60%;
        position: relative;
        left: 161px;
        .btn {
          margin-top: 22px;
          padding-bottom: 30px;
          .why {
            margin-left: 120px;
            font-size: 12px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #ff190c;
            margin-bottom: 22px;
            a {
              margin-left: 10px;
              font-size: 12px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #006fb8;
            }
          }
        }
      }
    }
  }
}
</style>
<style scoped>
.el-form >>> .el-form-item__label {
  line-height: 22px;
  padding: 0px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  margin-top: 2px;
}
.el-form >>> .el-form-item__content {
  line-height: 28px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #333333;
}
.el-form >>> .el-form-item {
  margin-bottom: 20px;
}
.el-form >>> .el-input {
  width: 468px;
}
.el-form >>> .el-input__inner {
  width: 468px;
  height: 28px;
}
.msg {
  margin-left: -55px;
}
.el-button--primary {
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #ffffff;
  min-width: 76px;
  height: 28px;
  line-height: 0px;
  background-color: #006fb8;
  text-align: center;
  margin-left: 105px;
}
.aa >>> .el-form-item__label::before {
  content: "*";
  color: red;
}
.el-textarea >>> .el-textarea__inne {
  min-height: 450px !important;
}
.aa {
  width: 592px;
}
.bottom >>> .el-textarea__inne {
  min-height: 450px !important;
}
.category {
  width: 730px;

  padding-top: 35px;
}
.category >>> .el-form-item__label {
  position: relative;
  left: -12px;
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #333333;
  line-height: 19px;
}
.category >>> .el-textarea__inner {
  margin-left: 5px;
}
</style>
<style scoped>
.right >>> .el-collapse-item__header {
  border-bottom: 1px solid #006fb8 !important;
  height: 36px;
}
/* .right >>> .el-collapse-item__arrow {
	float: left;
	position: absolute;
	left: 90px;
} */
.right >>> .el-checkbox {
  margin: 10px 0px 0px 45px;
}

.el-checkbox >>> .el-checkbox__label {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #666666;
}
</style>
